// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"315":"component---src-pages-innovation-js","605":"9f03370314dff27333129af59577c40e6bc8e0a5","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"315":"c5325696aae7245661d5","605":"35b20298d2d1daf09b29","678":"cc1d41edd5e0692eb46e","883":"f5d15e81247ce7569ae2"}[chunkId] + ".js";
};